

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  desc: {
    id: 'home.meta.desc',
    defaultMessage: 'Get massive savings on exclusive Steam bundles and great PC, Mac, and Linux games - updated daily. Join our community of over 2.6 million gamers - explore Fanatical now!',
  },
  title: {
    id: 'home.meta.title',
    defaultMessage: 'Buy PC Games, Steam Keys, Game Bundles',
  },
  new_releases: {
    id: 'home.title.newreleases',
    defaultMessage: 'New Releases',
  },
  trending_deals: {
    id: 'home.title.trendingdeals',
    defaultMessage: 'Trending Deals',
  },
  coming_soon: {
    id: 'home.title.comingsoon',
    defaultMessage: 'Upcoming Games',
  },
  newandupcoming: {
    id: 'home.title.newandupcoming',
    defaultMessage: 'New and Upcoming Releases',
  },
  upcoming_games: {
    id: 'home.title.upcominggames',
    defaultMessage: 'Upcoming Games',
  },
  most_gifted: {
    id: 'home.title.mostgifted',
    defaultMessage: 'Most Gifted',
  },
  bundles: {
    id: 'home.title.bundles',
    defaultMessage: 'More Game Bundles',
  },
});

export default messages;
